export default __webpack_public_path__ + "static/media/IBimageKneeanglemidswing1.b1b275a2.png";